import React from 'react'
import { Col,Button,Row } from 'reactstrap';
import { Dialog } from 'primereact/dialog';



export const ModalPreviewSamplings = (props) => {

    const {modalSamplings,handleToggleSamplings,saveSamplings,loadingSamplings,formMicSampling,cancell_Samplings,saveEditSamplings} = props;

    

    return (
        <Dialog 
            header={formMicSampling.validate_cancell ? "Cancelar datos de la muestra" : "Confirmar datos de la muestra"}
            visible={modalSamplings}
             onHide={handleToggleSamplings}
            headerStyle={{
                    backgroundColor: (formMicSampling.validate_cancell) ? '#c0130aff' : '#0d3b59',
                    color: 'white',
                    fontWeight: 'bold',
                }}
            pt={{
                    header: { style: { backgroundColor: formMicSampling.validate_cancell ? '#c0130aff' : '#0d3b59', color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                }}
            className="pt-0 custom-dialog-img-sample"
            footer={
                <>
                    {
                        formMicSampling.validate_cancell   && <Button color='secondary' onClick={cancell_Samplings} >Aceptar</Button>
                    }
                    {
                        (!loadingSamplings && !formMicSampling.validate_cancell) && <>
                        <Button disabled={loadingSamplings ? true : false} color={loadingSamplings ? "primary text-center" : "secondary text-center" }  type="button" onClick={() => (formMicSampling.is_edit ?  saveEditSamplings() : saveSamplings())}   >{"Aceptar"}</Button>
                        </>
                    }
               </>

            }
        >   
            { !formMicSampling.validate_cancell && <div className="socialprofile filter-cards-view p-l-0 p-b-0 p-r-0">
             {loadingSamplings &&<Row className='mt-2'>
                 <Col sm="12" md="12" lg="12" className='text-center p-l-0 p-r-0'>
                 <img alt="flask" className='animate__animated animate__pulse animate__infinite'  src={require("../../../assets/images/loginHelenLabs/HelenLabs.png")} style={{ width: "100px", height: "100px" }} />
                 <br />
                 <label style={{color:"#565a5efc", fontWeight: "bold", fontSize:"15px"}}>Guardando datos de la muestra:</label>&nbsp;&nbsp;
                 <Col sm="3" className='badge-detail-micro'  >
                 <Row>
                    <Col sm="1">
                    </Col>
                     <Col sm="10" className='p-l-0 p-r-0' style={{textAlign:"justify"}} >
                     {formMicSampling.sample_Form.folio ?? "--"}
                    </Col>
                    </Row>
                 </Col>
                 </Col>
                 </Row>}
             {!loadingSamplings && <Row>
                 <Col sm="12" style={{textAlign:"center"}} className='pt-3' >
                 <img alt="flask"  src={require("../../../assets/images/price/warningRecollected.svg")} style={{ width: "90px", height: "90px" }} />
                 </Col>
                 <Col sm="12" className='pt-1' style={{textAlign:"center"}}>
                 <label style={{color:"#565a5efc", fontWeight: "bold", fontSize:"15px"}} >Esta seguro de guardar los siguientes cambios </label> <br />
                 </Col> 
             </Row>} 
               
             </div>}

             {formMicSampling.validate_cancell && <>
                 <Col sm="12" style={{textAlign:"center"}} className='pt-3' >
                 <img alt="flask"  src={require("../../../assets/images/price/warningRecollected.svg")} style={{ width: "90px", height: "90px" }} />
                 </Col>
                 <Col sm="12" className='pt-1' style={{textAlign:"center"}}>
                 <label className='txt-danger f-14 f-w-700' >Se perderan los cambios que ya se habian llenado </label> <br />
                 </Col> 
             </>
                }
        </Dialog>
        
    )
}